<main>
    <app-header></app-header>
    <app-banner></app-banner>
    <app-about></app-about>
    <app-jobs></app-jobs>
    <app-proyects></app-proyects>
    <app-aboutestudios></app-aboutestudios>
    <app-contact></app-contact>
    <app-footer></app-footer>
</main>